import PageHeader from "app/shared/PageHeader";
import "./Flights.scss";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";

import Typography from "app/shared/Typography";
import FlightRecon from "./components/FlightRecon";
import IndigoLogo from "static/images/logoairline/Indigo.png";
import AkasaLogo from "static/images/logoairline/akasaair.png";
import AirAsiaLogo from "static/images/logoairline/Airasia.png";
import SpiceJetLogo from "static/images/logoairline/Spicejet.png";
import { Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
export default function NonBSP(props: any) {
  const [activeTab, setActiveTab] = useState("Transaction Data");
  const [userDetails, _] = useRecoilState<any>(userInfo);
  const [selectedAirline, setSelectedAirline] = useState<string>("indigo");
  const airlines = [
    { id: "indigo", name: "IndiGo", logo: IndigoLogo },
    { id: "akasa", name: "Akasa Air", logo: AkasaLogo },
    { id: "airaisa", name: "Air Asia", logo: AirAsiaLogo },
    { id: "spicejet", name: "SpiceJet", logo: SpiceJetLogo },

  ];
  const selectedAirlineObj =
    airlines.find((a) => a.id === selectedAirline) || airlines[0];
  const airlineMenu = {
    items: airlines.map((a) => ({
      key: a.id,
      label: (
        <div className="AirlineOption">
          <img className="AirlineLogo" src={a.logo} alt={a.name} />
          <Typography variant="xs" style={{ marginLeft: 8 }}>
            {a.name}
          </Typography>
        </div>
      ),
    })),
    onClick: ({ key }: any) => setSelectedAirline(key),
  };

  return (
    <div className="Flights">
      <div className="ScreenContainer">
        <PageHeader
          title="Non BSP"
          leftActions={
            <div className="HeaderTabs">
              {["Transaction Data", "Divide PNR Data", "SAP_Format_KG-Invoice", "SAP_Format_KR-Refund"].map((tab) => (
                <div
                  key={tab}
                  className={"TabItem" + (activeTab === tab ? " active" : "")}
                  onClick={() => setActiveTab(tab)}
                >
                  <Typography variant="xs">{tab}</Typography>
                </div>
              ))}
            </div>
          }
        />

        <div className="ContentRow">
          <div className="TableActions">
            <div className="AirlineSelector">
              <Typography variant="xs" style={{ marginBottom: 4 }}>
                Airline
              </Typography>
              <div className="SelectedAirline">
                <div className="AirlineDisplay">
                  <img
                    className="AirlineLogo"
                    src={selectedAirlineObj.logo}
                    alt={selectedAirlineObj.name}
                  />
                  <Typography variant="xs" style={{ marginLeft: 6 }}>
                    {selectedAirlineObj.name}
                  </Typography>
                </div>
                <Dropdown menu={airlineMenu} trigger={["click"]} placement="bottomLeft">
                  <div className="AirlineDropdownTrigger">
                    <DownOutlined />
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>
          <div className="TableContainer">
            <FlightRecon activeTab={activeTab} />
          </div>
        </div>
      </div>
    </div>
  );
}
